import * as Article from '@elevio/kb-kit/lib/components/article';
import * as Articles from '@elevio/kb-kit/lib/components/articles';
import * as Category from '@elevio/kb-kit/lib/components/category';
import * as Search from '@elevio/kb-kit/lib/components/search';
import { useTranslation } from '@elevio/kb-kit/lib/hooks';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import CategoryList from '../components/CategoryList';
import Footer from '../components/Footer';
import PageLayout from '../components/layouts/Page';
import WithAsideLayout, { Aside, Main, MainBody, MainHeader, } from '../components/layouts/WithAside';
import { fetchAgencyFlags } from '../requests/agency-flags';
import { getSubmissions } from '../requests/user-submission';
import Validator from '../utils/Validators';
import { DEFAULT_CRM_TOKEN, loginRequestsIconUrl, submitRequestIconUrl, viewAllRequestsIconUrl, } from '../utils/constants';
import { crmToken, privateSubmissionUrl } from '../utils/privateSubmissionUrl';
import { getHeader } from './home';
const AGENCY_ID = 672;
function Page() {
    const { t: translate } = useTranslation();
    const [displayRequestField, setDisplayRequestField] = useState(false);
    const [contactInfo, setContactInfo] = useState('');
    const [displayRequestFieldType, setDisplayRequestFieldType] = useState('EMAIL');
    const [errorMessage, setErrorMessage] = useState('');
    const [responseMessage, setResponseMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [showViewAllRequests, setShowViewAllRequests] = useState(false);
    const requestSubmissionContainer = useRef(document.createElement('div'));
    const requestSubmissionContainerMobile = useRef(document.createElement('div'));
    useEffect(() => {
        document.addEventListener('mousedown', handleClick);
        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, []);
    useEffect(() => {
        let cancelled = false;
        fetchAgencyFlags(AGENCY_ID).then((data) => {
            if (!cancelled) {
                setShowViewAllRequests(Boolean(data === null || data === void 0 ? void 0 : data.isPublicMapEnabled));
            }
        });
        return () => {
            cancelled = true;
        };
    }, []);
    const openPrivateSubmission = (path) => {
        const url = privateSubmissionUrl(path);
        if (!url) {
            return;
        }
        const newWindow = window.open(url, '_blank');
        if (newWindow) {
            newWindow.opener = null;
        }
    };
    const handleViewAllRequests = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission('public-map');
    };
    const isMobile = () => {
        return (navigator.userAgent.match(/Android/i) != null ||
            navigator.userAgent.match(/iPhone/i) != null);
    };
    const handleClick = (e) => {
        if (isMobile() &&
            requestSubmissionContainerMobile.current &&
            !requestSubmissionContainerMobile.current.contains(e.target)) {
            setErrorMessage('');
            setDisplayRequestField(false);
            setResponseMessage('');
        }
        else if (!isMobile() &&
            requestSubmissionContainer.current &&
            !requestSubmissionContainer.current.contains(e.target)) {
            setErrorMessage('');
            setDisplayRequestField(false);
            setResponseMessage('');
        }
    };
    const toggleRequestField = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (displayRequestField) {
            setErrorMessage('');
        }
        setDisplayRequestField(!displayRequestField);
    };
    const getRequestFieldTypeHandler = (type) => {
        return () => {
            setDisplayRequestFieldType(type);
            setErrorMessage('');
        };
    };
    const isEmailSelected = displayRequestFieldType === 'EMAIL';
    const isPhoneNumberSelected = displayRequestFieldType === 'PHONE_NUMBER';
    const onRequestSubmissionClick = () => {
        setErrorMessage('');
        const validator = new Validator();
        if (contactInfo &&
            (validator.isEmail(contactInfo) ||
                validator.isPhone(contactInfo))) {
            const token = process.env.CRM_TOKEN || DEFAULT_CRM_TOKEN;
            setLoading(true);
            getSubmissions(token, contactInfo)
                .then((result) => {
                setContactInfo('');
                setResponseMessage(result.message);
                setDisplayRequestField(false);
            })
                .catch((error) => {
                var _a, _b;
                setErrorMessage((_b = (_a = error === null || error === void 0 ? void 0 : error.message) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : 'Failed loading submissions');
            })
                .finally(() => setLoading(false));
        }
        else {
            let errorMessage = `Incorrect ${isEmailSelected ? 'email' : 'mobile number'} format`;
            if (!contactInfo || (contactInfo && !contactInfo.trim())) {
                errorMessage = 'The email or mobile number is required.';
            }
            setErrorMessage(errorMessage);
        }
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            onRequestSubmissionClick();
        }
    };
    const handleChangeEmail = (event) => {
        var _a;
        const value = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value;
        setContactInfo(value);
    };
    return (<PageLayout header={getHeader()} footer={<Footer />}>
      <section className="button-container button-container--three section-gap" aria-label="Quick actions">
        <div className="button-wrapper">
          <a href={`https://agency.comcate.com/private-submission/create?crm_token=${crmToken}`} className="cta-request" target="_blank" rel="noopener noreferrer">
            <img src={submitRequestIconUrl} alt="submit request icon" aria-hidden="true"/>
            Submit a Request
          </a>
        </div>
        <div className="button-wrapper">
          <a href={`https://agency.comcate.com/private-submission/listing?crm_token=${crmToken}`} className="cta-request" target="_blank" rel="noopener noreferrer">
            <img src={loginRequestsIconUrl} alt="my requests icon" aria-hidden="true"/>
            View My Requests
          </a>
        </div>
        {showViewAllRequests ? (<div className="button-wrapper">
            <button type="button" className="cta-request" onClick={handleViewAllRequests}>
              <img src={viewAllRequestsIconUrl} alt="view all requests icon" aria-hidden="true"/>
              View All Requests
            </button>
          </div>) : null}
        {/* COMMENTED OUT: Email/Phone submission logic - Keeping for future reference */}
        {/* <div
          ref={
            isMobile()
              ? requestSubmissionContainerMobile
              : requestSubmissionContainer
          }
          className="button-wrapper"
        >
          <button className="cta-request" onClick={toggleRequestField}>
            View Your Requests
          </button>
          {displayRequestField && (
            <div className="request-field-dropdown">
              <div className="request-field-dropdown-text">
                View your submission(s) by entering your associated email or
                phone number:
              </div>
              <div className="request-input-type-toggle-section">
                <button
                  className={cx('request-input-type-toggle-button', {
                    selected: isEmailSelected,
                  })}
                  disabled={loading}
                  onClick={getRequestFieldTypeHandler('EMAIL')}
                >
                  Email
                </button>
                <button
                  className={cx('request-input-type-toggle-button', {
                    selected: isPhoneNumberSelected,
                  })}
                  disabled={loading}
                  onClick={getRequestFieldTypeHandler('PHONE_NUMBER')}
                >
                  Phone Number
                </button>
              </div>
              {isEmailSelected && (
                <div className="request-input">
                  <input
                    placeholder="Enter your email address"
                    onKeyDown={handleKeyDown}
                    onChange={handleChangeEmail}
                  />
                  {errorMessage && <div id="error-message">{errorMessage}</div>}
                </div>
              )}
              {isPhoneNumberSelected && (
                <div className="request-input">
                  <PhoneInput
                    placeholder={'(xxx) xxx-xxxx'}
                    defaultCountry="US"
                    onKeyDown={handleKeyDown}
                    onChange={setContactInfo}
                  />
                  {errorMessage && <div id="error-message">{errorMessage}</div>}
                </div>
              )}
              <hr className="request-field-hr"></hr>
              <div className="request-action">
                <button
                  disabled={!contactInfo}
                  onClick={onRequestSubmissionClick}
                >
                  Submit
                </button>
              </div>
            </div>
          )}
          {responseMessage && (
            <div className="request-field-dropdown response-message-container">
              <div className="response-message">
                <span onClick={() => setResponseMessage('')}>x</span>
                <div>{responseMessage}</div>
              </div>
            </div>
          )}
        </div> */}
      </section>
      <WithAsideLayout>
        <Main>
          <MainHeader>
            <h1 className="main-title" data-testid="category-title">
              <Category.Title />
            </h1>
          </MainHeader>

          <MainBody data-testid="category-body">
            <Articles.Loop>
              <Article.Link className="article-link link-color" data-testid="article-link">
                <div>
                  <h3 className="article-link-title">
                    <Article.Title />
                  </h3>
                  <div className="article-link-summary">
                    <Article.Summary />
                  </div>
                </div>
              </Article.Link>
            </Articles.Loop>
          </MainBody>
        </Main>

        <Aside>
          <Search.Input className="sidebar-search" placeholder={translate('search.shortplaceholder', 'Search...')} data-testid="category-search-input"/>
          <CategoryList />
        </Aside>
      </WithAsideLayout>
    </PageLayout>);
}
export default Page;
